// extracted by mini-css-extract-plugin
export default {"root":"Echfjw","icon":"Z98HNI","up":"phghKF","right":"LrFJ3K"};